export default __webpack_public_path__ + "static/media/foot1.5e6013df.jpg";